/**
 * The AI-Native Coaching Maturity Ladder — customer-language rendering data
 * (doctrine spine: docs/content/shared/ai-native-coaching-maturity-ladder.md).
 * Shared by the member catalog and the shop-window (DRY): the visual IS the
 * promise — the Foundation installs L1–2, the Lab is the climb to L3–4.
 */
export type LadderState = 'before' | 'foundation' | 'climb';

export interface LadderStep {
  l: string;
  name: string;
  state: LadderState;
  desc: string;
}

export const LADDER: LadderStep[] = [
  { l: 'L0', name: 'Static', state: 'before', desc: 'Content + founder hours. AI = random prompts that don’t compound.' },
  { l: 'L1', name: 'Business Brain', state: 'foundation', desc: 'Your business context captured — AI sounds like you and sells your thing.' },
  { l: 'L2', name: 'Compounding Growth', state: 'foundation', desc: 'Your first evidence-backed improvement loop, running.' },
  { l: 'L3', name: 'AI-Native Delivery', state: 'climb', desc: 'Member-facing AI in your method’s voice — support, onboarding, proof.' },
  { l: 'L4', name: 'The AI-Native Company', state: 'climb', desc: 'The loops connect; the business gets stronger as models improve.' },
];

/** Map the doctrine ladder onto the shared render core's step shape. */
export function toCoreLadder(
  steps: LadderStep[],
  tags: { foundationTag?: string; climbTag?: string; beforeTag?: string } = {},
) {
  return steps.map((s) => ({
    code: s.l,
    name: s.name,
    desc: s.desc,
    state: (s.state === 'foundation' ? 'done' : s.state) as 'before' | 'done' | 'active' | 'climb',
    tag:
      s.state === 'foundation'
        ? tags.foundationTag
        : s.state === 'climb'
          ? tags.climbTag
          : tags.beforeTag,
  }));
}

/** Lanes of the climb (buyer taxonomy from the product-mining note). */
export const CLIMB_LANES = [
  { lane: 'Support', desc: 'answers in your voice, onboarding, member questions' },
  { lane: 'Sales/Follow-up', desc: 'replies, sequences, the next easy yes' },
  { lane: 'Proof', desc: 'capturing wins and turning them into assets' },
  { lane: 'Offer', desc: 'sharpening what you sell and how it’s packaged' },
];
